$('.testimonial-slider__carousel').slick({
                                             dots: true,
                                             infinite: true,
                                             speed: 800,
                                             slidesToShow: 1,
                                             adaptiveHeight: false,
                                             arrows: false,
                                             draggable: false,
                                             autoplay: true,
                                             autoplaySpeed: 4000,
                                             fade: true
                                         });
